module.exports = "/_next/static/images/cusa_logo_2025-3b7318060d30090f3ea979820be11e9a.svg";